import OnScreen from "./OnScreen";


function Home() {
  return <div className="home">
    <OnScreen />
  </div>
}

export default Home;
